import React from 'react';
import Skeleton from '@mui/material/Skeleton';
import { UiSwiper, UiSwiperItem } from 'ui-components';

const StorySwiperSkeleton = () => {
  return (
    <UiSwiper class='story-items skeleton'>
      {Array(10)
        .fill()
        .map((_, index) => (
          <UiSwiperItem class='story-item' key={index}>
            <div className='story-image'>
              <div className='story-image-header'>
                <Skeleton animation='wave' height={18} width='50%' />
                <Skeleton
                  variant='rounded'
                  animation='wave'
                  width={24}
                  height={24}
                />
              </div>
            </div>
            <div className='story-datetime'>
              <Skeleton
                animation='wave'
                height={18}
                width='25%'
                sx={{ marginTop: '10px', marginLeft: '10px' }}
              />
              <Skeleton
                animation='wave'
                height={18}
                width='25%'
                sx={{ marginTop: '10px' }}
              />
            </div>
          </UiSwiperItem>
        ))}
    </UiSwiper>
  );
};

export default StorySwiperSkeleton;
